import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const POINTS = [
  ["Why it costs more", "New drivers have no driving history yet, so insurers price in the unknown. It isn't personal; it's experience."],
  ["What you control", "Grades, training, where your teen lives during school and how they drive. Each one is a lever we can pull."],
  ["What we do", "We walk you through every discount your teen may qualify for and apply all of them, not just the obvious one."],
];

export const CostWorry = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section ref={ref} className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-36" data-testid="cost-worry-section">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] bg-graphite">
              <motion.img src="/img/parent-teen.jpg" alt="Parent with their teen next to the family car" style={{ y }} className="absolute inset-0 h-[120%] w-full object-cover" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_40%_45%,transparent_25%,rgba(10,13,18,0.85)_80%)]" />
              <p className="absolute bottom-6 left-6 right-6 font-mono text-xs uppercase tracking-[0.2em] text-bone">Parents, this part is for you</p>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:pt-10">
          <Reveal>
            <Eyebrow>Worried about the cost?</Eyebrow>
            <h2 className="mt-6 font-display text-5xl font-black uppercase leading-[0.92] text-bone sm:text-6xl lg:text-7xl">
              That sticker shock <span className="text-lane">has an answer.</span>
            </h2>
            <p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-mist sm:text-lg">
              Adding a new teen driver is often the biggest jump a family sees on its auto bill. The good news: insurers offer real discounts built for young drivers, and many of them can be combined.
            </p>
          </Reveal>
          <div className="mt-12 divide-y divide-white/10 border-y border-white/10">
            {POINTS.map(([t, d], i) => (
              <Reveal key={t} delay={i * 0.08}>
                <div className="group grid gap-3 py-7 sm:grid-cols-[80px_1fr_1.4fr] sm:items-baseline" data-testid={`cost-point-${i}`}>
                  <span className="font-mono text-sm text-lane">0{i + 1}</span>
                  <h3 className="font-display text-2xl font-bold uppercase text-bone transition-colors group-hover:text-lane">{t}</h3>
                  <p className="font-body text-sm leading-relaxed text-mist sm:text-base">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
